import * as React from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
const dateFormat = require('dateformat');

import styles from './Graph.scss';
import stylesVariables from '../_variables.scss';
import { Query } from '../../GraphQL';
import { DateLocale } from '../Date/date.locale';

const BYTES_TO_GIGABYTE = 1000000000;

interface GraphProps {
  title: string;
  period: string;
  data: Query['traffic'];
  locale: DateLocale;
}

const Graph: React.SFC<GraphProps> = ({ data, title, period, locale }) => {
  let xAxisStep = 0;

  switch (period) {
    case '48 h':
      xAxisStep = 40;
      break;
    case '48 hours':
    case '48 hodin':
      xAxisStep = 43;
      break;
    case '1 week':
    case '1 týden':
      xAxisStep = 102;
      break;
    case '365 days':
    case '365 dní':
      xAxisStep = Math.floor(365 / 5);
      break;
  }

  return (
    <div className={styles.container}>
      <div className="d-flex justify-content-between align-items-end mb-4">
        <h6 className={styles.title}>{title}</h6>
        <div className={styles.period}>{period}</div>
      </div>
      {data.length > 0 ? (
        <HighchartsReact
          highcharts={Highcharts}
          options={{
            chart: {
              type: 'line',
            },
            series: [
              {
                type: 'line',
                data: data.map(point => [point.timestamp.toString(), point.traffic]),
                color: stylesVariables['accent-color'],
                shadow: {
                  color: stylesVariables['accent-color'],
                  offsetX: 0,
                  offsetY: 7,
                  width: 6,
                  opacity: 0.03,
                },
                marker: {
                  enabled: false,
                },
                states: {
                  hover: {
                    enabled: false,
                  },
                },
              } as Highcharts.LineChartSeriesOptions,
            ],
            yAxis: {
              tickAmount: 4,
              tickInterval:
                Math.ceil(
                  Math.max(...data.map(point => point.traffic)) / 3 / (10 * BYTES_TO_GIGABYTE),
                ) *
                (10 * BYTES_TO_GIGABYTE),
              endOnTick: false,
              min: 0,
              labels: {
                useHTML: true,
                formatter() {
                  return `${(Math.round(this.value / BYTES_TO_GIGABYTE) / 1000).toFixed(1)}T`;
                },
                style: {
                  fontSize: '0.875rem',
                },
              },
              gridLineColor: stylesVariables['light-gray-color'],
              gridLineWidth: 2,
              gridLineDashStyle: 'ShortDash',
              title: {
                text: null,
              },
            },
            xAxis: {
              type: 'category',
              tickLength: 7,
              tickWidth: 1,
              tickInterval: xAxisStep,
              startOnTick: true,
              // endOnTick: true,
              minPadding: 0,
              maxPadding: 0,
              labels: {
                useHTML: true,
                style: {
                  fontSize: '0.875rem',
                },
                y: 40,
                align: 'left',
                formatter() {
                  const date = dateFormat(
                    new Date(parseInt(this.value + '000', 10)),
                    period === '365 days' || period === '365 dní' ? `mmm 'yy` : locale.shortFormat,
                  );

                  return date;
                },
              },
            },
            title: {
              text: null,
            },
            tooltip: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },
            credits: {
              enabled: false,
            },
          }}
        />
      ) : (
        <div className={styles.loader} />
      )}
    </div>
  );
};

export default Graph;



// WEBPACK FOOTER //
// /www/client/src/components/Graph/Graph.tsx